import $foreign from "./foreign.cjs";
var concatArray = $foreign.concatArray;
var concatString = $foreign.concatString;
export { concatArray, concatString };
